// @ts-nocheck
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { post } from "@insite/client-framework/Services/ApiService";
import { BunzlActions } from "@store/Framework/Store/Bunzl/BunzlReducer";
import mapCreditFormToApi from "@store/Library/Components/CreditForm/mapCreditFormToApi";
import { TermsSignatureData } from "@store/Library/Widgets/CreditForm/CreditFormForm";

import { Dispatch } from "redux";

const creditFormEndPoint = "creditapplication";
type HandlerType = ApiHandlerDiscreteParameter<
    { signatureData: TermsSignatureData } & HasOnSuccess & HasOnError,
    any,
    any
>;

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState();
    const websiteName = state.context.website.name;
    const creditForm = state.bunzl.pages.stepForm?.creditForm;
    const data = mapCreditFormToApi(creditForm, props.parameter.signatureData, websiteName);
    props.apiParameter = data;
};
export const submitDataToApi: HandlerType = async props => {
    const state = props.getState();

    const url = state.context.settings.settingsCollection.bunzlSettings?.creditFormApiUrl;
    try {
        const response = await post<string>(`${url}${creditFormEndPoint}`, props.apiParameter);
        props.apiResult = response;
    } catch (error) {
        props.parameter.onError?.();
        props.apiResult = "error";
    }
};

export const savePdfLink: HandlerType = props => {
    if (props.apiResult === "error") {
        return;
    }
    const dispatch = props.dispatch as Dispatch<BunzlActions>;
    dispatch({
        type: "Data/StepForm/SaveDownloadLink",
        downloadLink: props.apiResult,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult === "error") {
        return;
    }
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, submitDataToApi, ExecuteOnSuccessCallback, savePdfLink];

const submitCreditForm = createHandlerChainRunner(chain, "SubmitCreditForm");

export default submitCreditForm;
